import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";

export default {
  getFacilitiesGroups({ page, perPage, query, groups }) {
    const params = {
      page: page || 1,
      page_size: perPage || 8,
      name: query,
      ids: groups && groups.length ? groups.join(",") : undefined
    };
    return apiService.get(endpoints.facilitiesGroups, {
      params: pickBy(params)
    });
  },
  getAllFacilitiesGroups() {
    return apiService.get(endpoints.facilitiesGroups);
  },

  getFacilitiesGroupsIds({ name, groups } = { name: "", groups: [] }) {
    const params = {
      only_ids: true,
      name,
      ids: groups && groups.length ? groups.join(",") : undefined
    };
    return apiService.get(endpoints.facilitiesGroups, {
      params: pickBy(params)
    });
  },

  postFacilitiesGroup(facilitiesGroup) {
    return apiService.post(endpoints.facilitiesGroups, facilitiesGroup);
  },

  updateFacilitiesGroup(facilitiesGroup) {
    return apiService.patch(
      `${endpoints.facilitiesGroups}${facilitiesGroup.id}/`,
      facilitiesGroup
    );
  },

  deleteFacilitiesGroup(facilitiesGroupId) {
    return apiService.delete(
      `${endpoints.facilitiesGroups}${facilitiesGroupId}/`
    );
  },

  getFacilitiesIds(groups) {
    const params = {
      only_ids: true,
      groups: groups.join(",")
    };

    return apiService.get(endpoints.facilities, {
      params: pickBy(params)
    });
  }
};
